(
    window.onload = function() {
        const url = new URLSearchParams(window.location.search);
        if (url.get('redirectedFrom') !== null) {
            const trackingUtils = require('../js/modules/utils/tracking.utils');
            trackingUtils.trackEvent('redirection_msg', 'redirection_msg_onload');

            const homeContainer = document.getElementsByClassName('home')[0];

            const redirectionContainer = document.createElement('div');
            redirectionContainer.id = 'redirection-container';
            redirectionContainer.style.cssText = 'position: fixed; top: 0; width: 100%; height: 50px;' +
                ' background-color: #091180; display: flex; align-items: center; justify-content: space-between; color: white;';

            const redirectionTextContainer = document.createElement('div');
            redirectionContainer.id = 'redirection-text-container';
            redirectionTextContainer.innerHTML = `<p>${window.Odigeo.UIElements.translations.redirectText}</p>`;
            redirectionTextContainer.style.cssText = 'padding-left: 24px; padding-top: 16px; padding-bottom:16px; font-size: 14px;';

            const closeButton = document.createElement('div');
            closeButton.className = 'odf-icon odf-icon-cross-light';
            closeButton.style.cssText = 'cursor: pointer; padding-right: 24px;';

            redirectionContainer.appendChild(redirectionTextContainer);
            redirectionContainer.appendChild(closeButton);
            homeContainer.style.marginTop = '50px';
            homeContainer.appendChild(redirectionContainer);
            document.querySelector('#redirection-text-container p a').style.cssText = 'color: white; text-decoration: underline;';

            document.querySelectorAll('#redirection-text-container div')[1].addEventListener('click', () => {
                trackingUtils.trackEvent('redirection_msg', 'redirection_msg_close');
                redirectionContainer.style.display = 'none';
                homeContainer.style.marginTop = '0px';
            });

            document.querySelector('#redirection-text-container p a').addEventListener('click', () => {
                            trackingUtils.trackEvent('redirection_msg', 'redirection_msg_return-global');
                        });
        }
    })();
